/* Rappel d'achat de la fiche tirage (c28b-fiche-rappel-panier, 28/10) : snippets/bisou-rappel-panier.liquid.
   La barre se montre quand le bloc d'achat (.bisou-buy-row) est sorti de l'écran par le haut, et se cache
   dès qu'il revient ou que le volet « En savoir plus » est ouvert. Ses boutons cliquent les vrais boutons
   de la fiche : le panier reçoit le format et le cadre choisis, le volet s'ouvre comme d'habitude. */
(function () {
  'use strict';
  var root = document.getElementById('bisou-rappel-panier');
  var rangee = document.querySelector('.bisou-buy-row');
  if (!root || !rangee || !('IntersectionObserver' in window)) return;

  var html = document.documentElement;
  var prix = root.querySelector('[data-brp-prix]');
  var panier = root.querySelector('[data-brp-panier]');
  var panierTxt = panier.querySelector('span');
  var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dessus = false;
  var assoc = false;
  /* Les boutons d'Associez-le (.bvf-assoc__actions, bisou-ventes-fidelite) : la barre s'efface quand ils arrivent
     à 200 px sous le bas de l'écran, et ne revient qu'une fois qu'ils sont sortis par le haut. Elle a fini de
     s'effacer avant qu'ils entrent à l'écran, quelle que soit sa hauteur, même à la molette rapide (c29, 29/10). */
  var AVANCE = 200;

  function vraiPanier() { return document.querySelector('#atc button[name="add"], #atc [type="submit"]'); }
  function vraiInfo() { return document.querySelector('#bisou-mockup-btn .bmk-launch, #bisou-mockup-btn button'); }

  /* Volet « En savoir plus », tiroir du panier, menu ou vue agrandie : la barre s'efface. */
  function voletOuvert() {
    if (html.classList.contains('bmk-open') || html.classList.contains('bmk7-open')) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) return true;
    var l = vraiInfo();
    return !!(l && l.getAttribute('aria-expanded') === 'true');
  }

  /* Aperçu du thème : la barre Shopify passe devant tout en bas ; on se pose au-dessus (comme #bvf-sticky). */
  function lever() {
    var w = document.getElementById('PBarNextFrameWrapper');
    var vh = window.innerHeight || html.clientHeight, lift = 0;
    if (w) { var r = w.getBoundingClientRect(); if (r.height && r.top < vh) lift = Math.round(vh - r.top); }
    root.style.bottom = lift ? lift + 'px' : '';
    html.style.setProperty('--brp-lift', lift + 'px'); /* le pied s'allonge d'autant (CSS) */
  }

  function voirAssoc() {
    var vh = window.innerHeight || html.clientHeight, v = false;
    var l = document.querySelectorAll('.bvf-assoc__actions');
    for (var i = 0; i < l.length && !v; i++) {
      var r = l[i].getBoundingClientRect();
      v = r.height > 0 && r.bottom > 0 && r.top < vh + AVANCE;
    }
    if (v === assoc) return;
    assoc = v;
    maj();
  }

  var attente = 0;
  function surDefilement() {
    if (attente) return;
    attente = requestAnimationFrame(function () { attente = 0; voirAssoc(); });
  }

  function maj() {
    var on = dessus && !assoc && !voletOuvert();
    if (on) { lever(); copier(); }
    if (on === root.classList.contains('is-on')) return;
    root.classList.toggle('is-on', on);
    if (on) { root.removeAttribute('inert'); root.removeAttribute('aria-hidden'); }
    else {
      if (root.contains(document.activeElement)) document.activeElement.blur();
      root.setAttribute('inert', '');
      root.setAttribute('aria-hidden', 'true');
    }
  }

  /* Le prix et l'état du bouton suivent le vrai bouton d'achat (format, cadre, épuisé). */
  function copier() {
    var b = vraiPanier();
    if (!b) return;
    var p = b.querySelector('.bisou-atc-price');
    var montant = p ? p.textContent.trim() : '';
    /* « A3 encadré · 95 € » de la barre Achat rapide (#bvf-sticky, cachée ici mais tenue à jour), pris
       seulement s'il dit le format choisi et le prix du bouton ; sinon le prix seul. */
    var bvf = document.querySelector('#bvf-sticky [data-bvf-sticky-price]');
    var st = window.__bisouState;
    var long = bvf ? bvf.textContent.replace(/\s+/g, ' ').trim() : '';
    var net = function (x) { return x.replace(/\s+/g, ''); };
    if (long && montant && st && st.format && long.indexOf(st.format) === 0 && net(long).slice(-net(montant).length) === net(montant)) montant = long;
    if (montant && prix) prix.textContent = montant;
    var t = b.querySelector('span');
    if (t && t !== p && t.textContent.trim()) panierTxt.textContent = t.textContent.trim();
    var off = b.disabled || b.getAttribute('aria-disabled') === 'true';
    if (off) panier.setAttribute('aria-disabled', 'true'); else panier.removeAttribute('aria-disabled');
  }

  function remonter(puis) {
    window.scrollTo({ top: 0, behavior: doux ? 'smooth' : 'auto' });
    if (!puis) return;
    var fait = false;
    function fin() { if (fait) return; fait = true; window.removeEventListener('scrollend', fin); puis(); }
    window.addEventListener('scrollend', fin);
    setTimeout(fin, doux ? 900 : 60);
  }

  panier.addEventListener('click', function () {
    var b = vraiPanier();
    if (!b || b.disabled || panier.getAttribute('aria-disabled') === 'true') return;
    b.click();
  });

  root.querySelector('[data-brp-info]').addEventListener('click', function () {
    remonter(function () {
      var l = vraiInfo();
      if (l) { if (l.getAttribute('aria-expanded') !== 'true') l.click(); }
      else {
        var m = document.getElementById('bisou-mockup-mount');
        if (m) m.scrollIntoView({ behavior: doux ? 'smooth' : 'auto', block: 'start' });
      }
    });
  });

  root.querySelector('[data-brp-haut]').addEventListener('click', function () {
    remonter(function () {
      var b = vraiPanier();
      if (b) { try { b.focus({ preventScroll: true }); } catch (e) { /* vieux navigateur */ } }
    });
  });

  new IntersectionObserver(function (entrees) {
    var e = entrees[entrees.length - 1];
    dessus = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
    voirAssoc();
    maj();
  }).observe(rangee);
  window.addEventListener('scroll', surDefilement, { passive: true });
  window.addEventListener('resize', surDefilement, { passive: true });

  new MutationObserver(maj).observe(html, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(maj).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  var tiroir = document.querySelector('cart-drawer');
  if (tiroir) new MutationObserver(maj).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
  var atc = document.getElementById('atc');
  if (atc) new MutationObserver(copier).observe(atc, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  /* Le bouton « En savoir plus » est posé par bisou-mockup.js après le chargement. */
  var ancre = document.getElementById('bisou-mockup-btn');
  if (ancre) new MutationObserver(maj).observe(ancre, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });

  root.setAttribute('inert', '');
  root.setAttribute('aria-hidden', 'true');
  root.removeAttribute('hidden');
  html.classList.add('brp-on');
  copier();
})();
